import type { Member, User } from "./types";

const avatarColors = ["#2563eb", "#7c3aed", "#b7791f", "#be123c", "#475569"];

function initialsFromParts(primary: string, fallback: string) {
  const initials = primary
    .trim()
    .split(/\s+/)
    .filter(Boolean)
    .map((part) => part[0])
    .join("")
    .slice(0, 2)
    .toUpperCase();

  return initials || fallback.trim().slice(0, 2).toUpperCase() || "?";
}

function stableColorKey(value: string) {
  let hash = 0;
  for (const char of value) {
    hash = (hash * 31 + char.charCodeAt(0)) >>> 0;
  }
  return avatarColors[hash % avatarColors.length];
}

export function userInitials(user: User) {
  return initialsFromParts(user.display_name, user.email);
}

export function memberInitials(member: Member) {
  return initialsFromParts(member.display_name, member.email);
}

export function userAvatarColor(user: User) {
  return stableColorKey(user.id || user.email);
}

export function memberAvatarColor(member: Member) {
  return stableColorKey(member.user_id || member.email);
}
